import React, { useMemo, useCallback } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { formatPrice } from '../../../../utils';
import { getProductPurchaseUrl, selectPlanAndRedirect, insertTagPurchaseUrl, hasBenefitCode } from '../../../../utils/plan';
import { setUpsellPurchase } from '../../../../actions/purchaseActions';

import styles from '../styles.module.css';
import matomoTracker from '../../../../utils/matomo';
import dataLayer from '../../../../utils/dataLayer';
import { SalaVipIcon } from '../../../../assets/icons/SalaVip.icon';
import { ChipInternacionalIcon } from '../../../../assets/icons/ChipInternacional.icon';

const TagUpsell = '84';

const PlanCard = ({
  plan,
  highlight = false,
  buttonText,
  prices,
  pixDiscountMultiplier,
  providers,
  match,
  setUpsellPurchase,
  sourceTags = [],
}) => {
  if (!plan) return null;

  const productPurchaseUrl = useMemo(() => getProductPurchaseUrl(match, plan.code), [match, plan.code]);
  const hasSalaVip = useMemo(() => hasBenefitCode(plan, '68'), [plan]);
  const hasChipInternacional = useMemo(() => hasBenefitCode(plan, '64'), [plan]);
  const { finalPrice, parcels } = prices || {};

  const provider = providers.find((p) => p.code === plan.provider_code);
  const providerImgPath = provider ? `/assets/images/seguradoras/${provider.slug}.png` : '';

  const selectPlan = useCallback(() => {
    const tags = [...sourceTags];
    if (highlight) {
      matomoTracker.trackEvent('Conversão_Upsell', 'Clicou em fazer o upgrade - e foi para próxima etapa');
      dataLayer.upsellAccepted(plan);
      setUpsellPurchase(plan.code);
      tags.push(TagUpsell);
    } else {
      matomoTracker.trackEvent('Conversão_Upsell', 'Continuar com cobertura básica');
      dataLayer.upsellRejected(plan);
    }

    selectPlanAndRedirect(insertTagPurchaseUrl(productPurchaseUrl, tags));
  }, [productPurchaseUrl, highlight, setUpsellPurchase, plan.code, sourceTags]);

  return (
    <div className={highlight ? styles.cardHighlight : styles.cardNormal}>
      {highlight && !(hasSalaVip && hasChipInternacional) && (
        <div className={styles.tag}>
          <span role="img" aria-label="dobro de segurança">
            🛡️
          </span>{' '}
          Mais segurança
        </div>
      )}
      {(hasSalaVip && hasChipInternacional) && (
        <div className={styles.badgesRow}>
          {hasSalaVip && (
            <div className={styles.badgePill}>
              <SalaVipIcon />
              <span>Sala VIP</span>
            </div>
          )}
          {hasChipInternacional && (
            <div className={styles.badgePill}>
              <ChipInternacionalIcon />
              <span>Chip Internacional</span>
            </div>
          )}
        </div>
      )}
      <div className={styles.cardHeader}>
        {providerImgPath && <img alt={plan.name} className={styles.cardImage} src={providerImgPath} />}
        <div className={styles.cardTitle}>
          <p>{plan.name}</p>
        </div>
      </div>
      <div className={styles.priceContainer}>
        <div className={styles.priceRow}>
          <span className={`${styles.priceValue} ${highlight ? styles.priceValueGreen : ''}`}>
            R$ {formatPrice(finalPrice * pixDiscountMultiplier)}
          </span>
          <span className={styles.priceSuffix}>/ preço por pessoa</span>
        </div>
        <p className={styles.priceInstallment}>
          ou R$ {formatPrice(finalPrice)} até {parcels}x s/ juros no cartão
        </p>
      </div>
      <button className={highlight ? styles.buttonPrimary : styles.buttonOutline} onClick={selectPlan}>
        {buttonText}
      </button>
    </div>
  );
};

const PlanCards = ({
  upsellPlans,
  currentPrices,
  upgradePrices,
  pixDiscountMultiplier,
  providers,
  match,
  setUpsellPurchase,
  upsellSourceTags,
}) => {
  const currentPlan = upsellPlans && upsellPlans[0];
  const upgradePlan = upsellPlans && upsellPlans[1];

  return (
    <div className={styles.cardsContainer}>
      {/* Card Destaque */}
      <PlanCard
        plan={upgradePlan}
        buttonText="Garantir cobertura recomendada"
        highlight={true}
        prices={upgradePrices}
        pixDiscountMultiplier={pixDiscountMultiplier}
        providers={providers}
        match={match}
        setUpsellPurchase={setUpsellPurchase}
        sourceTags={upsellSourceTags}
      />

      {/* Card Normal */}
      <PlanCard
        plan={currentPlan}
        buttonText="Continuar com cobertura básica"
        highlight={false}
        prices={currentPrices}
        pixDiscountMultiplier={pixDiscountMultiplier}
        providers={providers}
        match={match}
        sourceTags={upsellSourceTags}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  providers: state.global.providers,
  upsellSourceTags: state.search.upsellSourceTags || [],
});

export default withRouter(connect(mapStateToProps, { setUpsellPurchase })(PlanCards));



// WEBPACK FOOTER //
// ./src/components/V2/upsell/components/PlanCards.jsx